import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import {Home, CodeOfConduct, Activity, TimeTablePage, Organizers} from '../Pages';
import './App.scss';
import Navigation from '../Components/Navigation';
import Footer from '../Components/Footer';

const event = {
    nav: {
        btnText: '티켓 오픈 메일 받기',
    },
};

class App extends Component {


    render() {
        return (
            <div className="App">
                <Navigation btnText={event.nav.btnText}/>
                <div className="content-wrapper">
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/codeOfConduct" component={CodeOfConduct}/>
                    <Route exact path="/activity" component={Activity}/>
                    <Route exact path="/timeTable" component={TimeTablePage}/>
                    <Route exact path="/organizer" component={Organizers}/>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default App;
